import { TablefilterMultiplePipe } from './../../shared/pipes/tablefilter-multiple.pipe';
import { Component, OnInit, OnDestroy } from '@angular/core';
import {NavigationEnd, Router, ActivatedRoute} from '@angular/router';
import { Order } from '../../models/orders.model';
import { MyoderService } from '../shared/myoder.service';
import { sortingInfo } from '../../models/filter.model';
// tslint:disable-next-line:import-blacklist
import { Subject } from 'rxjs';
import { Sort } from '@angular/material/sort';
import { FileService } from '../../services/file.service';
import { ManageService } from '../../services/manage.service';
import { NgProgress } from 'ngx-progressbar';
import { CommonService } from '../../services/common.service';
import {filter, takeUntil} from 'rxjs/operators';
import { NgProgressService } from '../../services/ngProgress.service';

declare var $: any;

@Component({
  selector: 'app-shipped-orders',
  templateUrl: './shipped-orders.component.html',
  styleUrls: ['./shipped-orders.component.css']
})
export class ShippedOrdersComponent implements OnInit, OnDestroy {

  title = 'Recently Invoiced Orders';
  orders: Order[];
  sortedData: Order[];
  // search
  searchField: string;
  sortingInfoObj: sortingInfo = {
    comparedProperty: '',
    sortingOrder: ''
  };
  filterResultArr: any;
  filterInput: string;
  hasEmptyFilterResult = false;
  loadContent = false;

  ngUnsubscribe: Subject<void> = new Subject<void>();
  narrow: boolean = false;
  selectedOrder = '';
  constructor(
    private router: Router,
    private orderService: MyoderService,
    private manageService: ManageService,
    private fileService: FileService,
    public ngProgress: NgProgressService,
    private commonService: CommonService,
    private activatedRouter : ActivatedRoute
  ) {
    commonService.emitUpdateSideBarActiveItem('orders');
   }

  ngOnInit() {
    this.loadContent = false;

    const url = this.router.url;
    const urlArray = url.split('/');

    if (urlArray[urlArray.length - 1] !== 'shippedorders') {
      this.loadContent = true;  // set to true to avoid load two loading screen at the same time
    }
    if(this.router.url == '/myOrder/shippedorders') {
      this.narrow = false;
    } else {
      this.narrow = true;
    }
    this.orderService.getShippedOrders('').pipe(takeUntil(this.ngUnsubscribe))
     .subscribe((value: Order[]) => {
      this.orders = value;
      this.sortedData = this.orders.slice();
      this.loadContent = true;
    },
      (error: any) => {
        // tslint:disable-next-line:no-console
        console.info(error.error.responseMessage);
        this.loadContent = true;
      });

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      if (this.router.url === '/myOrder/shippedorders' || this.router.url === '/myAccount/shippedorders') {
        $('#levelOne').animate({ scrollLeft: -250 }, 400);
        this.narrow = false;
      } else{
        this.narrow = true;
      }

    });
  }

  goOrderDetail(order: Order) {
    this.router.navigate(['orderitemdetail', order.orderNo + order.orderSuffix], {relativeTo: this.activatedRouter});
    this.selectedOrder = `${order.orderNo}${order.orderSuffix}` ;
  }

  ngOnDestroy() {
    this.commonService.emitUpdateSideBarActiveItem('');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  toHTML(input: any): any {
    return new DOMParser().parseFromString(input, 'text/html').documentElement.innerHTML;
  }

  searchOrder(): void {
    this.orderService.monitorSearchKeyWordChange(this.searchField);
    this.router.navigateByUrl('/myOrder/searchorders');
  }

  watchOrder(order: Order): void {
    this.orderService.monitorOrderDetaiChange(order);
  }

  onChange() {
    this.filterResultArr = new TablefilterMultiplePipe().transform(
      this.orders, ['orderNo', 'dateInvoiced', 'resellerPO', 'courier', 'connote'], this.filterInput);

    if (this.filterResultArr.length === 0) {
      this.hasEmptyFilterResult = true;

    } else {
      this.hasEmptyFilterResult = false;
    }
  }

  filterReset() {
    this.filterInput = '';
    this.hasEmptyFilterResult = false;
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  close() {
    if (this.router.url === `/myAccount/openorders` || this.router.url === `/myAccount/shippedorders`) {
      this.router.navigateByUrl('/myAccount');
    } else {
      this.router.navigateByUrl('/myOrder');
      if (this.narrow) {
        $('#levelOne').animate(
          { scrollLeft: (-252) },
          {
            duration: 400,
            complete: function () {
              $('.combination-loader').stop(true, false);
            }
          });
      }
    }
  }

  sortData(sort: Sort) {
    const data = this.orders.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'invoiveNo': return compare(a.orderNo, b.orderNo, isAsc);
        case 'invoiceDate': return compare(a.dateInvoiced.split('-').reverse().join('-'), b.dateInvoiced.split('-').reverse().join('-'), isAsc);
        case 'resellerPO': return compare(a.resellerPO, b.resellerPO, isAsc);
        case 'totalEx': return compare(parseFloat(a.totalEx), parseFloat(b.totalEx), isAsc);
        default: return 0;
      }
    });
  }

  ExportInvoicedOrder(option: string): void {
    this.ngProgress.start();
    // let exportData = this.sortedData.slice();
    // if (option !== 'All') {
    //   let startDate = moment().subtract(1, 'month').endOf('month'); // last month last day
    //   let endDate = moment().add(1, 'month').startOf('month'); // next month first day

    //   if (option === 'LastMonth') {
    //     startDate = moment().subtract(2, 'month').endOf('month');
    //     endDate = moment().startOf('month'); // current month first day

    //   }

    //   exportData = exportData.filter(item => moment(item.dateInvoiced, 'DD-MM-YYYY').isBetween(startDate, endDate));
    // }
    const fileName = `InvoicedOrders_${option}`;
    this.manageService.ExportInvoicedOrderLink(fileName).subscribe((res: string) => {
      const downloadURL = window.location.origin + res;
      window.location.href = downloadURL;
      this.ngProgress.done();
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }

  ExportInvoicedOrderLink(option: string) {
    const fileName = `InvoicedOrders_${option}`;
    this.manageService.ExportInvoicedOrderLink(fileName).subscribe((res: string) => {
      if (res) {
        console.log(res);
        const downloadURL = window.location.origin + res;
        // console.log(downloadURL);
        this.copyToClipboard(downloadURL);
        this.commonService.implementToast('Invoiced Order download link copied to clipboard successfully', 'Success');
      }
    },
      (error: any) => {
        console.error(error);
        this.commonService.implementToast('Get Invoiced Order download url failed', 'Error');
      });
  }

  copyToClipboard(item: any): void {
    const listener = (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', (item));
      e.preventDefault();
    };

    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);
  }

  exportOrderSerials(orderNumber: string, orderSuffix: string) {
    this.orderService.exportExportOrderSerials(orderNumber, orderSuffix)
    .subscribe(data => {
      const fileName = `DD_OrderSerials_${orderNumber}.xlsx`;
        this.fileService.saveAsExcelFile(data, fileName);
    },
    (error: any) => {
      console.error(error);
    });
  }

  convertTotal(total: string) {
    if (total.includes('-')) {
        return `-$${total.replace('-', '')}`;
    } else {
        return '$' + total;
    }
   }

   clickDownload(event: any) { // this function fixed bootstrap4 need click twice to open dropdown issue
    event.preventDefault();
    event.stopPropagation();
    $('#dropdownMenuButton').click();
   }
}

function compare(a, b, isAsc) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
